import axios from "axios";

export const SaveMultipleBettingSites = async (baseUrl, shortName) => {
    
    const token = siteMapToken[shortName] || '';
    
    const headersList = {
        Accept: "*/*",
        "Authorization": "Bearer " + token,
    };
    const reqOptions = {
        url: baseUrl + "/api/Site/save-multiple-site-bettings",
        method: "POST",
        headers: headersList,
    };
    const response = await axios.request(reqOptions);

    return response;
}

const siteMapToken = {
  "lc7": 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiIxIiwibmFtZSI6ImFkbWluIiwicm9sZUlkIjoiMSIsInJvbGUiOiJBZG1pbiIsImp0aSI6IjM0YzUzY2YzLTViYTktNGVkYi1hMGY4LWY3MmU4MWY1OTczNiIsImV4cCI6MjA3NTYxNDE4NCwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo1MDAxLyIsImF1ZCI6Imh0dHA6Ly9sb2NhbGhvc3Q6NTAwMS8ifQ.ElmlnYQqy2BvLFGmP991C5yaem3n-54eY9oQvKFXLUQ',
  "mnb": 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiIxIiwibmFtZSI6ImFkbWluIiwicm9sZUlkIjoiMSIsInJvbGUiOiJBZG1pbiIsImp0aSI6Ijk5MTg5MDU1LTRlMjYtNGVjNy05MzZmLTYzNzNkNWNkY2JjMiIsImV4cCI6MjA3NTYxNTMzOCwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo1MDAxLyIsImF1ZCI6Imh0dHA6Ly9sb2NhbGhvc3Q6NTAwMS8ifQ.SoaFOoEf05OMRAz4AOv08jwrBdmq-MJVYWRBenMoPDs',
  '777': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiIxIiwibmFtZSI6ImFkbWluIiwicm9sZUlkIjoiMSIsInJvbGUiOiJBZG1pbiIsImp0aSI6IjQ0MDlhYzk0LTUyNDgtNDM4ZC1hMTBhLTFlOTNlNjFlMTBkMSIsImV4cCI6MjA3NzkzODM0NywiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo1MDAxLyIsImF1ZCI6Imh0dHA6Ly9sb2NhbGhvc3Q6NTAwMS8ifQ.swBKn2L2ZhhrnthLR_s87YUBbmi5z9iUXHjbv73X8tk',
  "ep":  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiIxIiwibmFtZSI6ImFkbWluIiwicm9sZUlkIjoiMSIsInJvbGUiOiJBZG1pbiIsImp0aSI6ImE3MWNlZWNkLWIxMzktNDExNi05ZmNiLWFkZmYyZDI2OWNmZCIsImV4cCI6MjA4MzgwOTYzNSwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo1MDAxLyIsImF1ZCI6Imh0dHA6Ly9sb2NhbGhvc3Q6NTAwMS8ifQ.vSqoqIsoex0tpJInAHiGbxPvT_hlGJpf8khgJ5MBNdc',
}